import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { injectIntl } from 'react-intl';
import {
  Button, Form, FormGroup, Label,
} from 'reactstrap';

import { logout } from 'src/auth';
import FlashesStore from 'src/stores/FlashesStore';
import { tracingState } from 'src/tracing';
import { shutdownIntercom } from 'src/util/intercom';
import logger from 'src/util/logger';

import { AuthLogoutContainer } from '../AuthContainer';

class AuthLogout extends React.Component {
  handleConfirmLogout = async (e) => {
    e.preventDefault();
    const { intl, router } = this.props;
    const mutationName = 'authLogout';

    const response = await logout({
      onCompleted: () => {
        FlashesStore.flash(FlashesStore.SUCCESS, intl.formatMessage({ id: 'auth.auth_logout.form.response_message.success', defaultMessage: 'Logged out successfully' }), mutationName);
      },
      onError: (error) => {
        FlashesStore.flash(FlashesStore.ERROR, error.message, mutationName);
        logger.log({ message: 'error signing out', error });
      },
    });
    if (response) {
      shutdownIntercom();
      router.push('/login');
      tracingState.clearUserID();
      tracingState.clearPropertyID();
    }
  };

  render() {
    const { intl, router } = this.props;
    const pageTitle = intl.formatMessage({ id: 'auth.auth_logout.page.title', defaultMessage: 'Logout of Enosi' });
    const formTitle = intl.formatMessage({ id: 'auth.auth_logout.form.title', defaultMessage: 'Confirm logout' });
    const confirmMsg = intl.formatMessage({ id: 'auth.auth_logout.form.confirmation.message', defaultMessage: 'Are you sure you want to leave?' });
    const goBackLabel = intl.formatMessage({ id: 'auth.auth_logout.form.go_back.label', defaultMessage: '« Go back' });
    const logOutLabel = intl.formatMessage({ id: 'auth.auth_logout.form.log_out.label', defaultMessage: 'Log out' });

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageTitle}</title>
        </Helmet>
        <AuthLogoutContainer title={formTitle}>
          <Form onSubmit={this.handleConfirmLogout}>
            <FormGroup>
              <Label htmlFor="formConfirm">{confirmMsg}</Label>
            </FormGroup>
            <Button color="" onClick={() => (router.go(-1))}>
              {goBackLabel}
            </Button>
            {' '}
            <Button type="submit" color="primary">
              {logOutLabel}
            </Button>
          </Form>
        </AuthLogoutContainer>
      </>
    );
  }
}

AuthLogout.propTypes = {
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  router: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default injectIntl(AuthLogout);
